// DK-11201 printable area at 300 DPI: 991 × 272 px (landscape)
const W = 991, H = 272;
const MX = 18;
const FONT = 'Arial, Helvetica, sans-serif';

const up = s => (s || '').toUpperCase();

function clip(ctx, text, maxWidth) {
  if (!text) return '';
  if (ctx.measureText(text).width <= maxWidth) return text;
  let t = text;
  while (t.length > 1 && ctx.measureText(t + '…').width > maxWidth) t = t.slice(0, -1);
  return t + '…';
}

function getEndpoint(cable, side) {
  const item = cable[side];
  const brk  = cable[`${side}Breaker`];
  if (brk) {
    const room = brk.switchboard?.room
      ? brk.switchboard.room.text || ''
      : (brk.switchboard?.name || '');
    return {
      room,
      system: '',
      desc: `[${brk.switchboard?.name ?? 'SB'}] ${brk.tag}`,
    };
  }
  if (item) {
    return {
      room:   item.room?.text   || '',
      system: item.system?.name || '',
      desc:   item.description  || item.itemType || '',
    };
  }
  return { room: '', system: '', desc: '' };
}

function drawRow(ctx, leftText, rightText, y) {
  const avail = W - 2 * MX;
  if (rightText) {
    const rw = Math.min(ctx.measureText(rightText).width + 4, avail * 0.42);
    ctx.fillText(clip(ctx, leftText, avail - rw - 12), MX, y);
    const cr = clip(ctx, rightText, avail * 0.42);
    ctx.fillText(cr, W - MX - ctx.measureText(cr).width, y);
  } else {
    ctx.fillText(clip(ctx, leftText, avail), MX, y);
  }
}

export function generateCableLabelCanvas(cable) {
  const canvas = document.createElement('canvas');
  canvas.width  = W;
  canvas.height = H;
  const ctx = canvas.getContext('2d');

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = '#000000';
  ctx.textBaseline = 'top';

  const from = getEndpoint(cable, 'from');
  const to   = getEndpoint(cable, 'to');

  let y = 8;

  // Row 1: Tag (bold) left + cable type right
  const tag      = up(cable.tag             || '');
  const typeText = up(cable.cableType?.name || '');
  ctx.font = `bold 46px ${FONT}`;
  ctx.fillText(clip(ctx, tag, W / 2 - MX - 8), MX, y);
  if (typeText) {
    ctx.font = `32px ${FONT}`;
    const cr = clip(ctx, typeText, W / 2 - MX - 8);
    ctx.fillText(cr, W - MX - ctx.measureText(cr).width, y + 8);
  }
  y += 54;

  // Separator
  ctx.fillRect(MX, y, W - 2 * MX, 2);
  y += 9;

  // Rows 2–5
  ctx.font = `32px ${FONT}`;

  // Row 2: From room + system
  drawRow(ctx, up(from.room), up(from.system), y);
  y += 36;

  // Row 3: From description
  ctx.fillText(clip(ctx, up(from.desc), W - 2 * MX), MX, y);
  y += 38;

  // Separator
  ctx.fillRect(MX, y, W - 2 * MX, 2);
  y += 9;

  // Row 4: To room + system
  drawRow(ctx, up(to.room), up(to.system), y);
  y += 36;

  // Row 5: To description
  ctx.fillText(clip(ctx, up(to.desc), W - 2 * MX), MX, y);
  y += 38;

  // Separator
  ctx.fillRect(MX, y, W - 2 * MX, 2);
  y += 9;

  // Row 6: Note
  ctx.font = `30px ${FONT}`;
  ctx.fillText(clip(ctx, cable.note ? `NOTE: ${up(cable.note)}` : 'NOTE:', W - 2 * MX), MX, y);

  return canvas;
}

export function getCableLabelDataUrl(cable) {
  return generateCableLabelCanvas(cable).toDataURL('image/png');
}
